import { Modal, Button } from "react-bootstrap";

const DeleteWarningModal = ({ showModal, setShowModal, handleConfirmDelete, deleteGoalData, setDeleteGoalId }) => {

  const handleCloseModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-5" >Are you sure you want to delete the goal: <span className="fw-bold clrgreen " >{deleteGoalData?.text} </span> ?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteWarningModal;
